import {DepositPolicyType} from './deposit-policy.type.model';
export class DepositPolicy {
  type: DepositPolicyType;
  description: string;
  constructor(type: DepositPolicyType, description?: string) {
    this.type = type;
    this.description = description;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/deposit-policy.model.ts